define('view/controller/booking/BookingRescheduleUrlBuilder',['require','lib/view/BookingUrlBuilder'],function (require) {
	
	var Parent = require('lib/view/BookingUrlBuilder');
    
    var _instance;

	/**
	 * @class BookingRescheduleUrlBuilder
	 */
	return Parent.extend({

        buildUrl: function (urlType, extParams) {
            var result = 'client/bookings/reschedule/' + this._bookingModel.id + '/';
            
            extParams = _.pick(extParams, 'date', 'time');
            result += this._buildStepUrl(extParams);

            return result;
        },
        
        _getUrlParams: function () {
			return {
				'date': this._bookingModel.get('start_date'),
				'time': this._bookingModel.get('start_time')
			};
		},

	}, {
        getInstance: function () {
    		if (!_instance) {
    			_instance = new this();
    		}
    		
    		return _instance;
    	}
    });
	
});
